var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBataiyoRoadmapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1474,
    cy: 29.4642,
    rx: 28.5939,
    ry: 28.7562,
    fill: "#C7C7C7",
    fillOpacity: 0.25
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1481,
    cy: 29.4637,
    rx: 18.5766,
    ry: 18.682,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8247 19.2334C37.5255 17.9233 35.9831 16.8841 34.2857 16.175C32.5882 15.466 30.7688 15.1011 28.9315 15.1011C27.0942 15.1011 25.2748 15.466 23.5774 16.175C21.8799 16.8841 20.3375 17.9233 19.0383 19.2334L21.8084 22.0268C22.7438 21.0835 23.8543 20.3352 25.0765 19.8247C26.2987 19.3142 27.6086 19.0515 28.9315 19.0515C30.2544 19.0515 31.5643 19.3142 32.7865 19.8247C34.0087 20.3352 35.1192 21.0835 36.0546 22.0268L38.8247 19.2334Z",
    fill: "#FF6534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0383 19.231C16.4145 21.8768 14.9404 25.4654 14.9404 29.2073C14.9404 32.9491 16.4145 36.5377 19.0383 39.1836L21.8084 36.3902C19.9193 34.4852 18.8579 31.9014 18.8579 29.2073C18.8579 26.5132 19.9193 23.9294 21.8084 22.0243L19.0383 19.231Z",
    fill: "#0072DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8279 19.231C41.4517 21.8768 42.9258 25.4654 42.9258 29.2073C42.9258 32.9491 41.4517 36.5377 38.8279 39.1836L36.0578 36.3902C37.947 34.4852 39.0083 31.9014 39.0083 29.2073C39.0083 26.5132 37.947 23.9294 36.0578 22.0243L38.8279 19.231Z",
    fill: "#0072DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0347 29.4049C32.7345 29.5629 33.2875 29.9128 33.6939 30.4546C34.1115 30.9851 34.3203 31.5946 34.3203 32.2831C34.3203 33.2989 33.9704 34.0946 33.2706 34.6702C32.5708 35.2459 31.5889 35.5337 30.3247 35.5337H24.416V23.5978H30.1385C31.3575 23.5978 32.3112 23.8687 32.9997 24.4104C33.6995 24.9522 34.0494 25.7141 34.0494 26.696C34.0494 27.3958 33.8632 27.9827 33.4907 28.4568C33.1295 28.9196 32.6442 29.2356 32.0347 29.4049ZM27.7344 28.3383H29.4105C30.2457 28.3383 30.6633 27.994 30.6633 27.3055C30.6633 26.5944 30.2457 26.2389 29.4105 26.2389H27.7344V28.3383ZM29.6644 32.8587C30.4997 32.8587 30.9173 32.5088 30.9173 31.809C30.9173 31.4478 30.8044 31.1713 30.5787 30.9794C30.3642 30.7875 30.0538 30.6916 29.6475 30.6916H27.7344V32.8587H29.6644Z",
    fill: "#0072DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8267 39.1792C37.5275 40.4893 35.9851 41.5285 34.2876 42.2376C32.5901 42.9466 30.7708 43.3115 28.9335 43.3115C27.0961 43.3115 25.2768 42.9466 23.5793 42.2376C21.8818 41.5285 20.3395 40.4893 19.0403 39.1792L21.8104 36.3858C22.7458 37.3291 23.8563 38.0774 25.0785 38.5879C26.3007 39.0984 27.6106 39.3611 28.9335 39.3611C30.2563 39.3611 31.5663 39.0984 32.7885 38.5879C34.0106 38.0774 35.1211 37.3291 36.0566 36.3858L38.8267 39.1792Z",
    fill: "#46A01C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBataiyoRoadmapIcon);
export default __webpack_public_path__ + "static/media/bataiyo-roadmap-icon.304a70d4d175dc6cb7bab7598c796680.svg";
export { ForwardRef as ReactComponent };